import { PropsWithChildren, HTMLAttributes } from 'react';

import './styles.scss';

export default function ContentAreaFrame({
  className = '',
  ...remainingProps
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div {...remainingProps} className={`content-area-frame ${className}`} />
  );
}
